"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALPHA_ProductCardCarousel = void 0;
var react_1 = __importStar(require("react"));
var BaseCarousel_1 = require("../base-carousel/BaseCarousel");
var classnames_1 = __importDefault(require("classnames"));
var product_card_carousel_module_scss_1 = __importDefault(require("./product-card-carousel.module.scss"));
var ALPHA_ProductCardCarousel = function (_a) {
    var _b;
    var id = _a.id, ariaLabel = _a.ariaLabel, heading = _a.heading, children = _a.children;
    var _c = (0, react_1.useState)(false), isReady = _c[0], setIsReady = _c[1];
    // This is used to reduce the CLS of the carousel. On first render the client does
    // not know size of the carousel so the carousel is rendered with a min height of 400px (an estimated size).
    // Once rendered the client knows the size of the carousel we then set min height to 0px.
    (0, react_1.useEffect)(function () {
        if (isReady === false)
            setIsReady(true);
    }, [isReady]);
    return (react_1.default.createElement("div", { "data-testid": "product-card-carousel", className: (0, classnames_1.default)(product_card_carousel_module_scss_1.default['product-card-carousel'], (_b = {},
            _b[product_card_carousel_module_scss_1.default['product-card-carousel--ready']] = isReady,
            _b)) },
        react_1.default.createElement(BaseCarousel_1.ALPHA_BaseCarousel, { id: id, heading: heading, numberOfItemsToShow: 5, ariaLabel: ariaLabel }, children)));
};
exports.ALPHA_ProductCardCarousel = ALPHA_ProductCardCarousel;
//# sourceMappingURL=ProductCardCarousel.js.map